import { useNavigate } from "react-router-dom";
import "./TermsOfService.css";

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <div className="terms-content">
        <button onClick={() => navigate(-1)} className="terms-back-btn">
          ← Geri
        </button>

        <h1 className="terms-title">📜 Kullanıcı Sözleşmesi ve Hizmet Şartları</h1>
        
        <p className="terms-date">Son Güncelleme: 7 Aralık 2025</p>

        <div className="terms-section">
          <h2>1. Hizmetin Kabulü</h2>
          <p>
            SavNot ("Hizmet") platformunu kullanarak, bu Kullanıcı Sözleşmesi'ni ("Sözleşme") 
            okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan edersiniz. Bu şartları kabul 
            etmiyorsanız, lütfen Hizmeti kullanmayınız.
          </p>
        </div>

        <div className="terms-section">
          <h2>2. İçerik Sorumluluğu</h2>
          <p>
            <strong>2.1.</strong> Platformda paylaştığınız tüm içerikler (gönderiler, yorumlar, 
            resimler, videolar, kabile oluşturmaları ve diğer materyaller) tamamen sizin 
            sorumluluğunuzdadır.
          </p>
          <p>
            <strong>2.2.</strong> Paylaştığınız içeriklerin yasal, etik ve platform kurallarına 
            uygun olduğundan emin olmak sizin sorumluluğunuzdadır.
          </p>
          <p>
            <strong>2.3.</strong> İçeriklerinizin üçüncü taraf haklarını (telif hakkı, marka, 
            mahremiyet hakları) ihlal etmemesini sağlamakla yükümlüsünüz.
          </p>
        </div>

        <div className="terms-section">
          <h2>3. Yasak İçerik ve Davranışlar</h2>
          <p>Aşağıdaki içerik ve davranışlar kesinlikle yasaktır:</p>
          <ul>
            <li>Yasadışı, tehditkar, taciz edici, iftira niteliğinde, müstehcen veya ahlaka aykırı içerikler</li>
            <li>Nefret söylemi, ırkçılık, ayrımcılık veya şiddeti teşvik eden içerikler</li>
            <li>Spam, aldatıcı veya yanıltıcı içerikler</li>
            <li>Başkalarının telif haklarını, ticari markalarını veya diğer fikri mülkiyet haklarını ihlal eden içerikler</li>
            <li>Kişisel verilerin izinsiz paylaşılması</li>
            <li>Zararlı yazılım, virüs veya kötü amaçlı kod içeren materyaller</li>
            <li>Platform sistemlerini manipüle etmeye veya otomasyona yönelik girişimler</li>
          </ul>
        </div>

        <div className="terms-section">
          <h2>4. İçerik Hakları ve Lisans</h2>
          <p>
            <strong>4.1.</strong> Platformda paylaştığınız içeriklerin tüm hakları size aittir.
          </p>
          <p>
            <strong>4.2.</strong> İçerik paylaşarak, SavNot'a bu içerikleri platformda göstermek, 
            işlemek, saklamak ve dağıtmak için dünya çapında, münhasır olmayan, telifsiz, 
            süresiz ve geri alınamaz bir lisans vermiş olursunuz.
          </p>
          <p>
            <strong>4.3.</strong> İçeriğinizi istediğiniz zaman silebilirsiniz, ancak kopyalanmış 
            veya önbelleğe alınmış versiyonların silinmesi zaman alabilir.
          </p>
        </div>

        <div className="terms-section">
          <h2>5. Gizlilik ve Veri Koruma</h2>
          <p>
            Kişisel verilerinizin işlenmesi Gizlilik Politikamız kapsamında gerçekleştirilir. 
            Platformu kullanarak Gizlilik Politikamızı kabul etmiş olursunuz.
          </p>
        </div>

        <div className="terms-section">
          <h2>6. Hesap Güvenliği</h2>
          <p>
            <strong>6.1.</strong> Hesabınızın güvenliğinden siz sorumlusunuz.
          </p>
          <p>
            <strong>6.2.</strong> Şifrenizi gizli tutmalı ve yetkisiz erişimi önlemek için 
            güvenli bir şifre kullanmalısınız.
          </p>
          <p>
            <strong>6.3.</strong> Hesabınızda gerçekleşen tüm faaliyetlerden siz sorumlusunuz.
          </p>
        </div>

        <div className="terms-section">
          <h2>7. Moderasyon ve İçerik Kaldırma</h2>
          <p>
            <strong>7.1.</strong> SavNot, bu Sözleşme'yi ihlal eden veya yasadışı içerikleri 
            önceden bildirimde bulunmaksızın kaldırma hakkını saklı tutar.
          </p>
          <p>
            <strong>7.2.</strong> Tekrarlayan ihlaller durumunda hesabınız askıya alınabilir 
            veya tamamen kapatılabilir.
          </p>
          <p>
            <strong>7.3.</strong> İçerik kaldırma kararlarımız nihai ve bağlayıcıdır.
          </p>
        </div>

        <div className="terms-section">
          <h2>8. Sorumluluk Reddi</h2>
          <p>
            <strong>8.1.</strong> SavNot, "OLDUĞU GİBİ" ve "MEVCUT OLDUĞU HALDE" esasıyla sunulmaktadır.
          </p>
          <p>
            <strong>8.2.</strong> Hizmetin kesintisiz, güvenli veya hatasız olacağına dair 
            herhangi bir garanti vermiyoruz.
          </p>
          <p>
            <strong>8.3.</strong> Kullanıcılar arasındaki etkileşimlerden veya kullanıcı 
            içeriğinden kaynaklanan zararlardan sorumlu değiliz.
          </p>
          <p>
            <strong>8.4.</strong> Platform üzerindeki üçüncü taraf bağlantıları veya içerikleri 
            kontrol etmeyiz ve bunlardan sorumlu değiliz.
          </p>
        </div>

        <div className="terms-section">
          <h2>9. Sorumluluk Sınırlaması</h2>
          <p>
            Yasal olarak izin verilen azami ölçüde, SavNot ve bağlı kuruluşları, doğrudan, 
            dolaylı, arızi, özel, cezai veya sonuç olarak ortaya çıkan herhangi bir zarardan 
            (kar kaybı, veri kaybı veya iş kesintisi dahil) sorumlu olmayacaktır.
          </p>
        </div>

        <div className="terms-section">
          <h2>10. Tazminat</h2>
          <p>
            Platform kullanımınızdan, içerik paylaşımınızdan veya bu Sözleşme'nin ihlalinden 
            kaynaklanan tüm taleplere, zararlara, kayıplara ve masraflara (avukatlık ücretleri 
            dahil) karşı SavNot'u, bağlı kuruluşlarını ve çalışanlarını tazmin etmeyi kabul 
            edersiniz.
          </p>
        </div>

        <div className="terms-section">
          <h2>11. Değişiklikler</h2>
          <p>
            SavNot, bu Sözleşme'yi önceden bildirimde bulunmaksızın değiştirme hakkını saklı 
            tutar. Değişiklikler bu sayfada yayınlandığı anda yürürlüğe girer. Platformu 
            kullanmaya devam ederek değişiklikleri kabul etmiş sayılırsınız.
          </p>
        </div>

        <div className="terms-section">
          <h2>12. Hizmetin Sonlandırılması</h2>
          <p>
            <strong>12.1.</strong> Hesabınızı istediğiniz zaman kapatabilirsiniz.
          </p>
          <p>
            <strong>12.2.</strong> SavNot, herhangi bir nedenle ve önceden bildirimde 
            bulunmaksızın hesabınızı askıya alma veya sonlandırma hakkını saklı tutar.
          </p>
        </div>

        <div className="terms-section">
          <h2>13. Uygulanacak Hukuk</h2>
          <p>
            Bu Sözleşme, Türkiye Cumhuriyeti yasalarına tabi olacaktır. Bu Sözleşme'den 
            kaynaklanan uyuşmazlıklar İstanbul mahkemelerinde çözümlenecektir.
          </p>
        </div>

        <div className="terms-section">
          <h2>14. İletişim</h2>
          <p>
            Bu Sözleşme veya Hizmet ile ilgili sorularınız için bizimle iletişime geçebilirsiniz.
          </p>
        </div>

        <div className="terms-section">
          <h2>15. Genel Hükümler</h2>
          <p>
            <strong>15.1.</strong> Bu Sözleşme'nin herhangi bir hükmünün geçersiz veya 
            uygulanamaz olması durumunda, diğer hükümler tam olarak geçerliliğini korur.
          </p>
          <p>
            <strong>15.2.</strong> SavNot'un bu Sözleşme kapsamındaki herhangi bir hakkını 
            kullanmaması, bu hakkından feragat ettiği anlamına gelmez.
          </p>
          <p>
            <strong>15.3.</strong> Bu Sözleşme, taraflar arasındaki tam anlaşmayı oluşturur ve 
            önceki tüm sözlü veya yazılı anlaşmaların yerine geçer.
          </p>
        </div>

        <div className="terms-acceptance">
          <p>
            <strong>Platform kullanarak, bu Kullanıcı Sözleşmesi'ni okuduğunuzu, anladığınızı 
            ve tüm şartları kabul ettiğinizi beyan edersiniz.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
